import { useCallback, useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { isNetworkOffline } from "../utils/requireNetwork";

/** Shared stale-while-revalidate loader for marketing showcase pages. */
export function useShowcaseFeedLoader({ fetchAction, items, pageSize = 9 }) {
  const dispatch = useDispatch();
  const [isUpdating, setIsUpdating] = useState(false);
  const [refreshFailed, setRefreshFailed] = useState(false);

  const load = useCallback(
    async ({ force = false, page = 1, limit = pageSize } = {}) => {
      if (!force && isNetworkOffline()) return;

      const hasCachedFeed = items.length > 0;
      setIsUpdating(true);
      if (!hasCachedFeed) setRefreshFailed(false);

      try {
        await dispatch(fetchAction({ page, limit, force })).unwrap();
        setRefreshFailed(false);
      } catch {
        if (hasCachedFeed) setRefreshFailed(true);
      } finally {
        setIsUpdating(false);
      }
    },
    [dispatch, fetchAction, items.length, pageSize]
  );

  useEffect(() => {
    load();
  }, [load]);

  return { load, isUpdating, refreshFailed };
}
